<template>
  <div
    :class="[
      'organism wysiwyg-block px-8',
      'container-' + organism.containerWidth,
    ]"
    :style="'background-color:' + organism.backgroundColor"
  >
    <div class="wrapper">
      <div class="text-content" v-html="organism.description"></div>
      <MoleculesButtons
        v-if="organism.button1"
        :buttons="organism"
        :button-colors="buttonColors"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  organism: Object,
});

onMounted(() => {
  if (props.organism?.containerWidth === "full-width") {
    addFullWidthSupport();
  }
});

const buttonColors = computed(() => {
  const buttonColorsArray = [];
  if (props.organism.button1Color) {
    buttonColorsArray.push(props.organism.button1Color);
  }
  if (props.organism.button2Color) {
    buttonColorsArray.push(props.organism.button2Color);
  }
  if (props.organism.button3Color) {
    buttonColorsArray.push(props.organism.button3Color);
  }
  return buttonColorsArray;
});
</script>
